<template>
    <div class="attendee-container flex-grow-1 p-1">
        <loading :active.sync="isLoading" :is-full-page="false"></loading>
        <ul>
            <attendee v-for="attendee in filteredAttendees" :key="attendee._id" v-bind:attendee="attendee"></attendee>
        </ul>
    </div>
</template>

<script>
import Attendee from './Attendee.vue';
import Loading from 'vue-loading-overlay';
import * as JsSearch from 'js-search';

export default {
    name: 'attendeelist',
    components: {
        Attendee,
        Loading,
    },
    computed: {
        attendees() {
            if (!this.event) return [];
            return this.event.attendees;
        },
        isLoading() {
            return !!this.event && !!this.event.loading;
        },
        event() {
            const id = this.$route.query.id;
            const event = this.$store.state.events.list.find(ev => ev._id === id);
            return event;
        },
        index() {
            const index = new JsSearch.Search('_id');
            index.searchIndex = new JsSearch.UnorderedSearchIndex();
            index.addIndex('data');
            index.addDocuments(this.attendees);
            return index;
        },
        filteredAttendees() {
            if (!this.index || !this.query) return this.attendees;
            return this.index.search(this.query);
        },
        query() {
            return this.$store.state.query;
        },
    },
    methods: {
        registerListeners() {
            function connect() {
                const event = this.event;
                if (event) this.$store.dispatch('fetchAttendees', event._id);
                console.log('Realtime updates enabled');
            }
            if (!this.socket) return;
            this.socket.removeAllListeners();
            this.socket.on('connect', connect.bind(this));
            if (this.socket.connected) connect.call(this);
            if (!this.event) return;
            this.socket.on(`update:${this.event._id}`, (attendee) => {
                this.$store.commit('updateAttendee', attendee);
            });
        },
    },
    mounted() {
        this.socket = require('socket.io-client')();
        this.registerListeners();
    },
    beforeDestroy() {
        if (!this.socket) return;
        console.log('try to disconnect');
        this.socket.close();
    },
    watch: {
        event() {
            this.registerListeners();
        },
    },
};
</script>

<style lang="scss">
.attendee-container {
    position: relative;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    min-height: 100px;
}
</style>